import { Component, OnInit, ElementRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AuthService } from 'src/app/core/auth/auth.service';
import { Router, ActivatedRoute } from '@angular/router';
import { PlatformDetectorService } from 'src/app/core/services/platform-detector.service';
import { NotificationsService } from 'src/app/shared/notifications/notifications.service';
import { LoaderService } from 'src/app/shared/components/loader/loader.service';

@Component({
    templateUrl: './esqueci-senha.component.html',
    styleUrls: ['./esqueci-senha.component.css'],
    encapsulation: ViewEncapsulation.None
})
export class EsqueciSenhaComponent implements OnInit {

    loginForm: FormGroup;
    token: string;


    public value: string[];


    constructor(
        private formBuilder: FormBuilder,
        private authService: AuthService,
        private router: Router,
        private platformDetectorService: PlatformDetectorService,
        private notificationsService: NotificationsService,
        private loader: LoaderService,
        private _Activatedroute: ActivatedRoute

    ) { }


    ngOnInit(): void {

        this._Activatedroute.paramMap.subscribe(params => {
            this.token = params.get('token');

            console.log(this.token)
        });

        this.loginForm = this.formBuilder.group({
            password: ['', Validators.required],
            password2: ['', Validators.required]
        });

        



    }


    alterar() {

        const password = this.loginForm.get('password').value;
        const password2 = this.loginForm.get('password2').value;

        if (password != password2) {
            this.notificationsService.toastNotify('error', 'Erro!', 'Senhas devem ser idênticas!');
            return
        }

        console.log("trocar senha.");


        if (this.token) {
            this.authService
                .changePassToken(password, this.token)
                .subscribe(
                    () =>{
                        this.notificationsService.toastNotify('success','Senha', 'Senha foi alterada com sucesso!');
                    
                        this.router.navigate(['/'])
                    } ,
                    error => {
                        console.log(error);
                        this.loginForm.reset();
                        
                        this.platformDetectorService.isPlatformBrowser()
                        if(error.status==404)
                        if(error.error.objects){
                            this.notificationsService.toastNotify('error',error.error.title, error.error.objects[0].userMessage);
                          }else
                          if(error.error.detail){
                            this.notificationsService.toastNotify('error',error.error.title, error.error.detail);
                          }else{
                          
                            if (typeof error.error === "string")
                              this.notificationsService.toastNotify('error', 'Erro!', error.error);
                            else
                              this.notificationsService.toastNotify('error', 'Erro!', error.message + ": " + error.status);
                          }

                    }
                );
        } else {
            this.authService
                .changePass(password)
                .subscribe(
                    () =>{
                        this.notificationsService.toastNotify('success','Senha', 'Senha foi alterada com sucesso!');
                    
                        this.router.navigate(['/'])
                    },
                    error => {
                        this.loginForm.reset();
                        this.platformDetectorService.isPlatformBrowser() 
                        if(error.status==404)
                        if(error.error.objects){
                            this.notificationsService.toastNotify('error',error.error.title, error.error.objects[0].userMessage);
                          }else
                          if(error.error.detail){
                            this.notificationsService.toastNotify('error',error.error.title, error.error.detail);
                          }else{
                          
                            if (typeof error.error === "string")
                              this.notificationsService.toastNotify('error', 'Erro!', error.error);
                            else
                              this.notificationsService.toastNotify('error', 'Erro!', error.message + ": " + error.status);
                          }

                    }
                );
        }

    }

}